import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const ProductCertificationDetailForm = forwardRef(({product, detail, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={detail}
      type="detail"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={({id, title, value}) => services.product.saveCertificationDetail(product, {id, title, value})}
      onSaved={onSaved}
    />
  );
});

export default ProductCertificationDetailForm;
